import { useEffect, useState } from 'react'
import type { Product } from '../data/products'

const ProductCarousel = ({ products }: { products: Product[] }) => {
  const [active, setActive] = useState(0)
  const count = products.length

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % count)
    }, 3500)
    return () => clearInterval(timer)
  }, [count])

  return (
    <div className="relative overflow-hidden rounded-lg bg-white shadow-xl shadow-slate-200/70">
      <div className="relative aspect-[4/5] w-full sm:aspect-[4/3] lg:aspect-[3/4]">
        {products.map((product, index) => (
          <div
            key={product.id}
            className={`absolute inset-0 flex flex-col items-center justify-center p-6 transition-opacity duration-700 ease-in-out ${
              index === active ? 'z-10 opacity-100' : 'z-0 opacity-0'
            }`}
            aria-hidden={index !== active}
          >
            <img
              src={product.image}
              alt={product.alt}
              width={320}
              height={320}
              className="mx-auto max-h-[76%] w-full max-w-[320px] object-contain"
            />
            <div className="mt-4 text-center">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-teal-700">
                {product.code}
              </p>
              <h3 className="mt-1 text-lg font-semibold text-slate-950">{product.name}</h3>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center gap-2 pb-5">
        {products.map((product, index) => (
          <button
            key={product.id}
            type="button"
            onClick={() => setActive(index)}
            aria-label={`Show ${product.name}`}
            className={`h-2 rounded-full transition-all ${
              index === active ? 'w-6 bg-teal-700' : 'w-2 bg-slate-300 hover:bg-slate-400'
            }`}
          />
        ))}
      </div>
    </div>
  )
}

export default ProductCarousel
